import "regenerator-runtime/runtime"
import _ from "lodash"
import { createClient } from "graphql-ws"
import { RelayNetworkLayer, urlMiddleware, loggerMiddleware, retryMiddleware } from "react-relay-network-modern"
import { Environment, RecordSource, Store, Observable } from "relay-runtime"

const NODE_ENV = process.env.NODE_ENV
const GRAPHQLAPI_SUBSCRIPTION_PATH = process.env.REACT_APP_GRAPHQLAPI_SUBSCRIPTION_PATH
const GRAPHQLAPI_PATH = process.env.REACT_APP_GRAPHQLAPI_PATH

let currentPayload
let currentSignedContext
let currentSession
let cachedEnvironment
let wsClient

const getHeaders = () => {
  const headers = {}
  if (currentSession) {
    headers['Authorization'] = `Bearer ${currentSession}`
  }
  if (!_.isEmpty(currentPayload) && currentSignedContext) {
    headers["X-Woztell-Payload"] = JSON.stringify(currentPayload)
    headers["X-Woztell-SignedContext"] = currentSignedContext
  }
  return headers
}

const setupSubscription = ({
  operation,
  variables,
}) => {
  if (!wsClient) {
    wsClient = createClient({
      url: GRAPHQLAPI_SUBSCRIPTION_PATH,
      connectionParams: () => ({
        payload: currentPayload,
        signedContext: currentSignedContext,
        session: currentSession
      })
    })
  }
  return Observable.create((sink) => {
    return wsClient.subscribe(
      {
        operationName: operation.name,
        query: operation.text,
        variables,
      },
      sink,
    )
  })
}

export const RelayEnvironment = ({
  payload,
  signedContext,
  session
} = {}) => {
  currentPayload = payload
  currentSignedContext = signedContext
  currentSession = session

  if (cachedEnvironment) {
    return cachedEnvironment
  }

  cachedEnvironment = new Environment({
    network: new RelayNetworkLayer([
      urlMiddleware({
        url: GRAPHQLAPI_PATH,
        headers: getHeaders,
        credentials: "include"
      }),
      navigator.userAgent !== "ReactSnap" ? retryMiddleware({
        fetchTimeout: 60000,
        retryDelays: (attempt) => {
          if (attempt > 2) {
            return false
          }
          return Math.pow(2, attempt + 4) * 100
        }
      }) : null,
      NODE_ENV === "production" ? null : loggerMiddleware()
    ], {
      subscribeFn: (operation, variables) => {
        return setupSubscription({ operation, variables })
      }
    }),
    store: new Store(new RecordSource()),
  })
  return cachedEnvironment
}
